import React from "react";



function NotFound(): JSX.Element {

    return <React.Fragment>

        <h1>
            <strong>
                Oops - Esta página no existe!
            </strong>
        </h1>

    </React.Fragment>;
}

export default NotFound;
